/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_YesInputs */

const en_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_subtitle_export_yes = /** @type {(inputs: Subtitle_Export_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Subtitle_Export_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_yes = /** @type {((inputs?: Subtitle_Export_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_yes(inputs)
	if (locale === "de") return de_subtitle_export_yes(inputs)
	if (locale === "it") return it_subtitle_export_yes(inputs)
	if (locale === "ru") return ru_subtitle_export_yes(inputs)
	if (locale === "es") return es_subtitle_export_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_yes(inputs)
	if (locale === "ja") return ja_subtitle_export_yes(inputs)
	if (locale === "hi") return hi_subtitle_export_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_yes(inputs)
	return en_subtitle_export_yes(inputs)
});